import type { FeatureCollection } from 'geojson'

export enum objectsNameENUM {
  programs = 'programs',
  events = 'events',
  organizations = 'organizations',
}

export type ObjectsMapType = {
  obj_type: string
  obj_id: number
}

export interface IMapProps {
  mapData: FeatureCollection
}
